import { useEffect, useState } from "react";
import { onToast, type Toast } from "../lib/toast";

/** 한 알림이 화면에 머무는 시간. 짧은 문구를 읽고 지나칠 만큼만. */
const TOAST_MS = 2200;

/**
 * 화면 아래에 잠깐 뜨는 알림.
 *
 * App 한 곳에만 둔다. 여러 곳에 두면 같은 알림이 여러 번 그려진다.
 *
 * `aria-live="polite"` 로 읽어 준다 — 시각적으로만 알리면 스크린리더 사용자는
 * 복사가 됐는지 알 방법이 없다. `assertive` 가 아닌 이유는 하던 일을 끊을
 * 만큼 중요한 내용이 아니기 때문이다.
 */
export function ToastHost() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(
    () =>
      onToast((toast) => {
        setToasts((prev) => [...prev, toast]);
        // 각자 자기 타이머로 사라진다. 하나로 묶으면 뒤에 온 것이 일찍 사라진다.
        setTimeout(
          () =>
            setToasts((prev) => prev.filter((entry) => entry.id !== toast.id)),
          TOAST_MS,
        );
      }),
    [],
  );

  if (toasts.length === 0) return null;

  return (
    <div className="toast-host" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <p key={toast.id} className="toast">
          {toast.message}
        </p>
      ))}
    </div>
  );
}
